<template>
    <div v-if="showInfoModal">
        <div class="popupModal" :class="{active: showInfoModal}">
            <div class="popupModal__wrapper">
                <div class="popupModal__content">
                    <div  v-if="false">
                         <span class="close-icon" @click="onClose">
                             <img src="@/assets/icons/ic_close_white.svg">
                        </span>
                    </div>
                    <div class="main-content">
                        <div class="block-title" v-if="!settings.showRedirectFailedMsg">You will be redirected to the Google review page in <span class="seconds_left">{{ secondsLeft }}</span> seconds</div>
                        <div class="block-title" v-else>Your browser blocked an automatic redirect to the Google review page.<br/>Please click on the button below:</div>
                        <div class="block-social__subtitle" v-if="settings.social_subtitle !== ''">{{settings.social_subtitle}}</div>
                        <div class="block-btn__wrapper"
                             @click="onLinkClick(settings.link)">
                            <div class="block-btn">
                                <img alt="" src="@/assets/icons/ic_google.svg">
                                <div>Write Google review</div>
                            </div>
                        </div>
                        <div class="block-btn__wrapper"
                             @click="onCancelClick()">
                            <div class="block-btn">
                                <div>Cancel</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import logAnalyticsEvent from '@/helpers/analytics'
import errorMixin from '@/mixins/errorMixin';


export default {
    name: "googleAutoReviewPopup",

    mixins: [mixin, errorMixin],

    data() {
        return {
            showInfoModal: this.settings !== null,
            secondsLeft: 3,
            timer: null,
            cancelled: false,
        }
    },

    watch: {
        settings(newValue) {
            this.showInfoModal = newValue !== null
        }
    },

    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {}
            }
        },
    },

    methods: {
        async onClose() {
            logAnalyticsEvent('social_link_popup_close_click')
            await this.closeSelf()
        },
        async closeSelf() {
            this.showInfoModal = false
            if (this.settings.onCancelHandler) {
                try {
                    await this.settings.onCancelHandler(this.settings)
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
        },
        onLinkClick(link) {
            if (this.settings.onLinkClickHandler) {
                try {
                    this.settings.onLinkClickHandler(link)
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
        },
        async onCancelClick() {
            this.cancelled = true
            this.timer = null
            await this.closeSelf()
        },
        restartTimer() {
            this.secondsLeft = 3
            this.cancelled = false
            this.runTimerTick()
        },
        runTimerTick() {
            this.timer = setTimeout(() => {
                if(!this.cancelled) {
                    this.secondsLeft -= 1
                    if (this.secondsLeft <= 0) {
                        this.timerFinished()
                    } else {
                        this.runTimerTick()
                    }
                }
            }, 1000)
        },
        timerFinished() {
            if (this.settings.onTimerFinishedHandler) {
                this.settings.onTimerFinishedHandler(this.settings.link)
            }
        },
    }

}
</script>

<style scoped>
.main-content {
    text-align: center;
    color: black;
    margin-bottom: 0;
    margin-top: 14px;
    padding-bottom: 0;
}

.close-icon {
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 99999;
    width: 40px;
    height: 40px;
    display: flex;
}

.close-icon img {
    max-width: 20px;
    margin: auto;
}
.main-content__title {
    margin-top: 0;
    color: black;
    margin-bottom: 20px;
}

.block-title {
    margin-bottom: 16px;
}
.popupModal__content {
    margin: 14.75em auto;
}
.block-social__subtitle {
  margin-bottom: 25px;
  font-size: 18px;
  color: #3F405C;
    white-space: pre-line
}
.seconds_left {
    font-weight: 800;
    font-size: 18px;
}

@media screen and (max-width: 376px) {
    .popupModal__content {
        margin: 10em auto;
    }
    .block-social__subtitle {
      font-size: 15px;
    }
}

@media screen and (max-width: 321px) {
    .popupModal__content {
        margin: 8em auto;
    }
}


</style>
